import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';

import { ProjectSelectorComponent } from './project-selector.component';
import { UserManualDirective } from '../../shared/user-manual/user-manual.directive';

@NgModule({
  imports: [CommonModule, FormsModule, SelectModule, UserManualDirective],
  declarations: [ProjectSelectorComponent],
  exports: [ProjectSelectorComponent],
})
export class ProjectSelectorModule {}
